export default __webpack_public_path__ + "static/media/refresh.1803f6e8.svg";